module.exports = __webpack_public_path__ + "img/nav_item_bg2_no_active.7b6424f7.png";